import { useEffect, useState } from 'react';
import { WORDPRESS_STATUS } from '../../../modules/AnchorAPI/v3/stations/fetchPodcastMetadata';
import { FETCH_WORDPRESS_STATUS } from './useEpisodeListMetadata';

export enum IMPORT_WORDPRESS_BLOG_STATUS {
  HIDE = 'HIDE',
  CAN_SHOW = 'CAN_SHOW',
  SHOW = 'SHOW',
}
export function useImportSuccessModal({
  wordpressStatus,
}: {
  wordpressStatus: WORDPRESS_STATUS | FETCH_WORDPRESS_STATUS;
}) {
  const [successModalStatus, setSuccessModalStatus] = useState<
    IMPORT_WORDPRESS_BLOG_STATUS
  >(IMPORT_WORDPRESS_BLOG_STATUS.HIDE);
  /*
   * manages showing the success modal after the user has imported their blog
   * posts for the first time.
   *
   * this is special because we only want to show the success modal once after
   * they have:
   * 1. connected WP to anchor
   * 2. successful initial import of blog posts
   *
   * so this effect checks to see that `wordpressStatus` transitions from:
   *    `connectedAccount` ----- to -----> `completedImport`
   */
  useEffect(() => {
    if (wordpressStatus === WORDPRESS_STATUS.CONNECTED_ACCOUNT) {
      setSuccessModalStatus(IMPORT_WORDPRESS_BLOG_STATUS.CAN_SHOW);
    }
    if (
      successModalStatus === IMPORT_WORDPRESS_BLOG_STATUS.CAN_SHOW &&
      wordpressStatus === WORDPRESS_STATUS.COMPLETED_IMPORT
    ) {
      setSuccessModalStatus(IMPORT_WORDPRESS_BLOG_STATUS.SHOW);
    }
  }, [wordpressStatus, successModalStatus]);

  function handleHideSuccessModal() {
    setSuccessModalStatus(IMPORT_WORDPRESS_BLOG_STATUS.HIDE);
  }
  return { successModalStatus, handleHideSuccessModal };
}
